import React, { useState, useEffect } from "react";
import UserPanel from "../Dashboard/UserPanel";
import UserPanel2 from "../Dashboard/UserPanel2";
import { Card, CardBody, Col, Container, Input, Label, Row } from "reactstrap";
import { useLocation } from "react-router-dom";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import OverView3 from "../Dashboard/Overview3";
import OverView2 from "../BatchControl/OverView2";
import MonthlyProductionStatus from "../BatchControl/MonthlyProductionStatus";
import MonthlyRequirementForm from "../AdvancedAnalysis/MonthlyRequirementForm";
import GraphPlotGoodBad from "./GraphplotGoodBad";
import axios from "axios";
import PageGrid from "../../components/GridLayout/PageGrid";

const getCurrentShift=()=>{const h=new Date().getHours();if(h>=6&&h<14)return 1;if(h>=14&&h<22)return 2;return 3;};
const getTodayDate=()=>new Date().toISOString().split("T")[0];

const ProductionDemand = () => {
  const location = useLocation();
  const machine = location.state?.part;
  const [machines,setMachines] = useState([]);
  const [parts,setParts] = useState([]);
  const selectedMachineId = localStorage.getItem("selectedMachineId");
  const [selectedMachine,setSelectedMachine] = useState(machine?.machine_id||selectedMachineId);
  const [selectedPart,setSelectedPart] = useState("");
  const [selectedDate,setSelectedDate] = useState(()=>machine?.date||getTodayDate());
  const [selectedShift,setSelectedShift] = useState(()=>machine?.shift||getCurrentShift());
  const [selectedMonth,setSelectedMonth] = useState(()=>{const n=new Date();return `${n.getFullYear()}-${String(n.getMonth()+1).padStart(2,"0")}`;});
  const [partsData,setPartsData] = useState({good_parts:0,bad_parts:0,total_parts:0,total_running_hours:0,stopped_time:0,machine:"",part:"",part_number:0});

  useEffect(()=>{fetch("https://api.hanoch.in/api/machines/by-company/?id=3").then(r=>r.ok?r.json():null).then(d=>d&&setMachines(d?.data||[])).catch(console.error);},[]);
  useEffect(()=>{if(!selectedMachine)return;axios.get(`https://api.hanoch.in/api/mcc-parts/?machine_id=${selectedMachine}`).then(r=>setParts(r.data||[])).catch(console.error);},[selectedMachine]);
  useEffect(()=>{if(parts.length>0&&!selectedPart)setSelectedPart(parts[0].id);},[parts]);

  const selectedMachineObject = machines.find(m=>m.id==selectedMachine);
  const isManual = selectedMachineObject?.manual??false;
  const selectedChildPart = selectedMachineObject?.parts;
  const [year,month] = selectedMonth.split("-");

  document.title = "Production Demand | OptiMize";

  const ControlsBar = (
    <Card className="mb-0 h-100">
      <CardBody className="p-2">
        <div className="d-flex flex-wrap align-items-center gap-3" style={{padding:"8px 12px"}}>
          <div className="d-flex align-items-center gap-1">
            <Label className="mb-0" style={{fontSize:13}}>Machine:</Label>
            <Input type="select" bsSize="sm" style={{minWidth:140}} value={selectedMachine||""} onChange={e=>setSelectedMachine(e.target.value)}>
              <option value="">Select Machine</option>
              {machines?.map((m,i)=><option key={i} value={m.id}>{m.name}</option>)}
            </Input>
          </div>
          <div className="d-flex align-items-center gap-1">
            <Label className="mb-0" style={{fontSize:13}}>Part:</Label>
            <Input type="select" bsSize="sm" style={{minWidth:120}} value={selectedPart} onChange={e=>setSelectedPart(e.target.value)}>
              <option value="">Select Part</option>
              {parts.map(p=><option key={p.id} value={p.id}>{p.part_name}</option>)}
            </Input>
          </div>
          <div className="d-flex align-items-center gap-1">
            <Label className="mb-0" style={{fontSize:13}}>Month:</Label>
            <input type="month" value={selectedMonth} max={new Date().toISOString().slice(0,7)}
              onChange={e=>setSelectedMonth(e.target.value)}
              style={{padding:"4px 8px",border:"1px solid #30363d",borderRadius:6,fontSize:13}}/>
          </div>
        </div>
      </CardBody>
    </Card>
  );

  const widgets = [
    { id:"controls",  label:"Controls",              icon:"mdi mdi-cog-outline",    defaultW:12, defaultH:3, minH:3, content: ControlsBar },
    { id:"kpi",       label:"KPI Stats",              icon:"mdi mdi-view-dashboard", defaultW:12, defaultH:5, minH:4, content: isManual ? <UserPanel2 partsData={partsData} selectedChildPart={partsData.part_number}/> : <UserPanel partsData={partsData} selectedChildPart={partsData.part_number}/> },
    { id:"monthly",   label:"Monthly Production",     icon:"mdi mdi-calendar-month", defaultW:12, defaultH:6, minH:5, content: <MonthlyProductionStatus machineId={selectedMachine} partId={selectedPart} year={year} month={month}/> },
    { id:"graph",     label:"Production Graph",       icon:"mdi mdi-chart-line",     defaultW:12, defaultH:7, minH:5, content: isManual ? <OverView2 partsDataMap={{}} selectedDate={selectedDate} selectedShift={selectedShift} selectedMachine={selectedMachine} selectedChildPart={selectedChildPart}/> : <GraphPlotGoodBad partsDataMap={{}} selectedDate={selectedDate} selectedShift={selectedShift} selectedMachine={selectedMachine} selectedChildPart={selectedChildPart} partId={selectedPart} year={year} month={month}/> },
    { id:"requirement",label:"Monthly Requirement",   icon:"mdi mdi-clipboard-list", defaultW:12, defaultH:6, minH:5, content: <MonthlyRequirementForm/>, defaultVisible:false },
  ];

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="OptiMize" breadcrumbItem="Production Demand" />
          <PageGrid pageKey="production_demand" widgets={widgets} />
        </Container>
      </div>
    </React.Fragment>
  );
};
export default ProductionDemand;
